import React from 'react'
import Layout from '../Layout'
import PreferenceForm from '../../../utils/CommonFunctionality/PreferenceFunction'
import DashboardHeader from '../DashboardHeader'
import { Container } from '@material-ui/core'
import QRCodeGenerator from './Qrcode'

const Qrcode = (props) => {
    const barcodeCenter = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    }

    return (
        <Layout props={props}>
            <div className="GFdashWrapperContainer">
                <DashboardHeader />
                <Container className="db-bids-wrapper mt-4 lq-db-table">
                    <h2 className="mp-head">Qrcode</h2>
                    <div style={barcodeCenter}>
                        <QRCodeGenerator />
                    </div>
                </Container>
            </div>
        </Layout>
    )
}

export default Qrcode
